import { Component, OnInit } from "@angular/core";
import {
  Select,
  Store,
  Actions,
  ofActionSuccessful,
  ofActionErrored,
} from "@ngxs/store";
import { UserState } from "src/app/states/user.state";
import { Place } from "src/app/interface/user";
import { MatDialogRef } from "@angular/material/dialog";
import { GetCellars } from "src/app/states/actions/admin.actions";
import { imgErrorFallback } from "src/app/helpers/helpers";
import { AlertService } from "src/app/services/alert.service";
import { GetSubmodules } from "src/app/states/actions/user.actions";
@Component({
  selector: "app-employee-places",
  templateUrl: "./employee-places.component.html",
  styleUrls: ["./employee-places.component.less"],
})
export class EmployeePlacesComponent implements OnInit {
  @Select(UserState.places) places;
  selectedPlace: Place;

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<EmployeePlacesComponent>,
    private actions: Actions,
    private alertService: AlertService
  ) {
    this.actions.pipe(ofActionSuccessful(GetSubmodules)).subscribe(() => {
      this.dialogRef.close();
    });
    this.actions.pipe(ofActionErrored(GetSubmodules)).subscribe(() => {
      this.alertService.openSnackBar(
        "Error de conexión.",
        "error",
        
      );
    });
  }

  ngOnInit() {
    this.selectedPlace = this.store.selectSnapshot<Place>(
      UserState.selectedPlace
    );
  }

  selectPlace = (place) => {
    this.store.dispatch(new GetSubmodules(place));
    const subs = this.actions
      .pipe(ofActionSuccessful(GetSubmodules))
      .subscribe(() => {
        subs.unsubscribe();
        this.store.dispatch(new GetCellars());
      });
  };

  onError = imgErrorFallback;
}
